import { createSlice } from "@reduxjs/toolkit";

const bookingIdSlice = createSlice({
  name: "bookingId",
  initialState: {
    bookingId: null,
  },
  reducers: {
    setBookingIdStore: (state, action) => {
      state.bookingId = action.payload ?? null;
    },
    clearBookingIdStore: (state) => {
      state.bookingId = null;
    },
  },
});

export const { setBookingIdStore, clearBookingIdStore } = bookingIdSlice.actions;
export const selectStoredBookingId = (state) => state.bookingId.bookingId;
export default bookingIdSlice.reducer;
